import { TextField, Box, Typography, Alert, AlertTitle } from '@mui/material';
import FieldWrapper from '../FieldWrapper';

export default function Step5Recapiti({ data, onChange, errors, metadata }) {
  const meta = (f) => metadata?.[f] || {};

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
      <Box>
        <Typography variant="h6" sx={{ fontWeight: 600, color: 'text.primary' }}>
          Come contattarti
        </Typography>
        <Typography variant="body2" sx={{ color: 'text.secondary', mt: 0.5 }}>
          Inserisci i tuoi recapiti principali
        </Typography>
      </Box>

      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        <FieldWrapper label="Cellulare" required error={errors?.cellulare} completed={!!data.cellulare} locked={meta('cellulare').editable === false} source={meta('cellulare').source} hint="Recapito prioritario per comunicazioni">
          <TextField fullWidth size="small" type="tel" value={data.cellulare || ''} onChange={e => onChange('cellulare', e.target.value)} placeholder="+39 3XX XXX XXXX" />
        </FieldWrapper>

        <Alert severity="warning" sx={{ borderRadius: 3 }}>
          <AlertTitle sx={{ fontWeight: 600 }}>Attenzione</AlertTitle>
          non inserire il cellulare di un'altra persona. Inserire sempre lo stesso numero di cellulare già comunicato a Compass in eventuali altri finanziamenti. Questa informazione è molto importante e può pregiudicare l'accettazione della pratica.
        </Alert>

        <FieldWrapper label="Indirizzo Email" required error={errors?.email} completed={!!data.email} locked={meta('email').editable === false} source={meta('email').source}>
          <TextField fullWidth size="small" type="email" value={data.email || ''} onChange={e => onChange('email', e.target.value)} placeholder="la.tua@email.it" />
        </FieldWrapper>

        <FieldWrapper label="Telefono Fisso" error={errors?.telefono_fisso} completed={!!data.telefono_fisso}>
          <TextField fullWidth size="small" type="tel" value={data.telefono_fisso || ''} onChange={e => onChange('telefono_fisso', e.target.value)} placeholder="Opzionale" />
        </FieldWrapper>

        <FieldWrapper label="Altro Recapito" error={errors?.altro_recapito} completed={!!data.altro_recapito}>
          <TextField fullWidth size="small" type="tel" value={data.altro_recapito || ''} onChange={e => onChange('altro_recapito', e.target.value)} placeholder="Opzionale" />
        </FieldWrapper>
      </Box>
    </Box>
  );
}